import * as DataTypes from '../../constants/dataTypes';
export const bypassPropertyGetterList = [DataTypes.UNIFIED_EVENTS];